import {
  IS_LOADING,
  // CONTEST_FOOTBALL_LIST_SUCCESS,
  ACTIVE_FOOTBALL_LIST_SUCCESS,
  UPCOMING_FOOTBALL_LIST_SUCCESS,
  UPCOMING_FOOTBALL_LIST_ERROR,
  ACTIVE_FOOTBALL_LIST_ERROR,
  POOL_LIST_SUCCESS,
  POOL_LIST_ERROR,
  POOL_STATUS_CHANGED_SUCCESS,
  POOL_STATUS_CHANGED_ERROR,
  FOOTBALL_MATCH_STATUS_CHANGED_SUCCESS,
  FOOTBALL_MATCH_STATUS_CHANGED_ERROR,
  POOL_PRIZE_BREAK_SUCCESS,
  POOL_PRIZE_BREAK_ERROR,
  ACTIVE_FOOTBALL_MATCH_POOL_LIST_SUCCESS,
  ACTIVE_FOOTBALL_MATCH_POOL_LIST_ERROR,
  // PUBLISH_MATCH_POOL_SUCCESS,
  // PUBLISH_MATCH_POOL_ERROR,
  PUBLISH_FOOTBALL_MATCH_POOL_SUCCESS,
  PUBLISH_FOOTBALL_MATCH_POOL_ERROR
} from "../actions/Type";

const initialState = {
  upcoming_football_match_list: {},
  active_football_match_list: {},
  pool_list: {},
  pool_add: {},
  match_status: {},
  pool_status: {},
  prize_break: {},
  active_pool_list_football:{},
  pool_publish : {},
  activeincpooldata : {},
  football_match_publish : {},
  loading: false,
};

const FootballReducer = (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case IS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case UPCOMING_FOOTBALL_LIST_SUCCESS:
      console.log("payload", payload);
      return {
        ...state,
        upcoming_football_match_list: payload,
        loading: false,
      };
    case UPCOMING_FOOTBALL_LIST_ERROR:
      return {
        ...state,
        upcoming_match_list: payload,
        loading: false,
      };
      case PUBLISH_FOOTBALL_MATCH_POOL_SUCCESS:
        return {
          ...state,
          football_match_publish: payload,
          loading: false,
        };
        case PUBLISH_FOOTBALL_MATCH_POOL_ERROR:
          return {
            ...state,
            football_match_publish: payload,
            loading: false,
          };
    case ACTIVE_FOOTBALL_LIST_SUCCESS:
      return {
        ...state,
        active_football_match_list: payload,
        loading: false,
      };
    case ACTIVE_FOOTBALL_LIST_ERROR:
      return {
        ...state,
        active_match_list: payload,
        loading: false,
      };
    case POOL_LIST_SUCCESS:
      return {
        ...state,
        pool_list: payload,
        loading: false,
      };
    case POOL_LIST_ERROR:
      return {
        ...state,
        pool_list: payload,
        loading: false,
      };
    //   case PUBLISH_MATCH_POOL_SUCCESS:
    //   return {
    //     ...state,
    //     pool_publish: payload,
    //     loading: false,
    //   };
    // case PUBLISH_MATCH_POOL_ERROR:
    //   return {
    //     ...state,
    //     pool_publish: payload,
    //     loading: false,
    //   };
    case POOL_STATUS_CHANGED_SUCCESS:
      return {
        ...state,
        pool_status: payload,
        loading: false,
      };
      case POOL_STATUS_CHANGED_ERROR:
            return {
                ...state,
                pool_status: payload,
                loading: false
            }
    case FOOTBALL_MATCH_STATUS_CHANGED_SUCCESS:
      return {
        ...state,
        match_status: payload,
        loading: false,
      };
      case FOOTBALL_MATCH_STATUS_CHANGED_ERROR:
            return {
                ...state,
                match_status: payload,
                loading: false
            }
            case POOL_PRIZE_BREAK_SUCCESS:
            return {
                ...state,
                prize_break: payload,
                loading: false
            }
            case POOL_PRIZE_BREAK_ERROR:
            return {
                ...state,
                prize_break: payload,
                loading: false
            }
            case ACTIVE_FOOTBALL_MATCH_POOL_LIST_SUCCESS:
              return {
                  ...state,
                  active_pool_list_football: payload,
                  loading: false
              }
  
          case ACTIVE_FOOTBALL_MATCH_POOL_LIST_ERROR:
              return {
                  ...state,
                  active_pool_list_football: payload,
                  loading: false
              }
    default:
      return state;
  }
};

export default FootballReducer;
